// Central list of API endpoint paths (all relative to /api).
export const Endpoints = {
  auth: {
    session: '/auth/session',
  },
  onboarding: {
    status: '/onboarding/status',
    dismiss: '/onboarding/dismiss',
    reset: '/onboarding/reset',
  },
  dashboard: {
    summary: '/dashboard/summary',
    profitChart: '/dashboard/profit-chart',
    topProducts: '/dashboard/top-products',
    recentOrders: '/dashboard/recent-orders',
  },
  products: {
    list: '/products',
    import: '/products/import',
    detail: (id: number) => `/products/${id}`,
    setCost: (id: number) => `/products/${id}/cost`,
    batch: '/products/cost/batch',
  },
  orders: {
    list: '/orders',
    detail: (id: number) => `/orders/${id}`,
    sync: '/orders/sync',
    export: '/orders/export',
  },
  adSpend: {
    list: '/ad-spend',
    summary: '/ad-spend/summary',
    create: '/ad-spend',
    batch: '/ad-spend/batch',
    remove: (id: number) => `/ad-spend/${id}`,
  },
  // Third-party integrations (Facebook/Google/TikTok/ShipStation) — routes DISABLED until
  // ad-platform credentials are configured. Kept here (dormant) so the Integrations page +
  // routes can be re-enabled trivially once credentials exist.
  integrations: {
    list: '/integrations',
    connect: (platform: string) => `/integrations/${platform}/connect`,
    disconnect: (platform: string) => `/integrations/${platform}/disconnect`,
    sync: (platform: string) => `/integrations/${platform}/sync`,
  },
  expenses: {
    list: '/expenses',
    summary: '/expenses/summary',
    create: '/expenses',
    update: (id: number) => `/expenses/${id}`,
    remove: (id: number) => `/expenses/${id}`,
  },
  reports: {
    profit: '/reports/profit',
    forecast: '/reports/forecast',
    export: '/reports/export',
  },
  settings: {
    get: '/settings',
    update: '/settings',
  },
  alerts: {
    list: '/alerts',
    metrics: '/alerts/metrics',
    events: '/alerts/events',
    create: '/alerts',
    update: (id: number) => `/alerts/${id}`,
    remove: (id: number) => `/alerts/${id}`,
  },
  support: {
    config: '/support/config',
    ask: '/support/ask',
    message: '/support/message',
    thread: '/support/thread',
  },
  // Billing — plan comparison, usage, and subscribe (used by the Billing page).
  billing: {
    plans: '/billing/plans',
    usage: '/billing/usage',
    subscribe: '/billing/subscribe',
  },
} as const;
